import { render, staticRenderFns } from "./dict-data-manage.vue?vue&type=template&id=218ecac0&scoped=true"
import script from "./dict-data-manage.vue?vue&type=script&lang=js"
export * from "./dict-data-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218ecac0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218ecac0')) {
      api.createRecord('218ecac0', component.options)
    } else {
      api.reload('218ecac0', component.options)
    }
    module.hot.accept("./dict-data-manage.vue?vue&type=template&id=218ecac0&scoped=true", function () {
      api.rerender('218ecac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/dict/dict-data-manage.vue"
export default component.exports